import React from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Box,
} from '@mui/material';
import {
  Add,
  Image as ImageIcon,
  Business,
  Group,
} from '@mui/icons-material';

const FloatingMenu = ({ anchorEl, open, onClose, onOptionPress }) => {
  const menuOptions = [
    {
      id: 'post',
      label: 'Post',
      icon: <Add />,
      color: '#4FC3F7',
    },
    {
      id: 'figure',
      label: 'Figure',
      icon: <img src="/assets/images/icons/png/Actionfigure.png" alt="Figure" style={{ width: 24, height: 24, objectFit: 'contain' }} />,
      color: '#FF9800',
    },
    {
      id: 'company',
      label: 'Company',
      icon: <Business />,
      color: '#9C27B0',
    },
    {
      id: 'group',
      label: 'Group',
      icon: <Group />,
      color: '#4CAF50',
    },
  ];

  const handleOptionClick = (option) => {
    onOptionPress(option);
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{
        zIndex: 10001,
      }}
      PaperProps={{
        elevation: 3,
        sx: {
          width: 200,
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.15))',
          mt: 1.5,
          borderRadius: 2,
          zIndex: 10001, // ensure floating menu appears above all content
          pointerEvents: 'auto', // make sure clicks reach the menu
          '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      {menuOptions.map((option) => (
        <MenuItem
          key={option.id}
          onClick={() => handleOptionClick(option)}
          sx={{
            py: 1.5,
            '&:hover': {
              backgroundColor: `${option.color}15`,
            },
          }}
        >
          <ListItemIcon>
            <Box
              sx={{
                color: option.color,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {option.icon}
            </Box>
          </ListItemIcon>
          <ListItemText
            primary={option.label}
            primaryTypographyProps={{ fontWeight: 500 }}
          />
        </MenuItem>
      ))}
    </Menu>
  );
};

export default FloatingMenu;
